<template lang="pug">
	
	header.header
		.header-wrapper
			.su-logo
				a(href='http://shoes-up.com' target='blank')
					img(src='assets/images/SU-logo.svg')
			burger-button(:action="menuIn")
			nav.nav
				p.electors-amount.nav-item
				p.credits-link.nav-item(@click="creditsIn") credits
				LangSwitcher.nav-item


</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'

	import LangSwitcher from '../controls/lang-switch.vue'
	import BurgerButton from '../controls/burger-button.vue'
	
	
  @Component({
		name: 'Header',
		components: {LangSwitcher, BurgerButton }
	})

	class Header extends Vue {

		mounted () {

			this._dom()
			this._on()
		
		}
		

		
		init () {}

		_on () {
			this.$events.on('header.in',this.show.bind(this))
			this.$events.on('header.out',this.hide.bind(this))
			this.$events.on('menu.out',this.menuOut.bind(this))
		}

		_dom () {
			this.$burger = this.$el.querySelector('.burger-button')
			this.$navItem = this.$el.querySelectorAll('.nav-item')
		}

		menuIn () {

			let tl = new TimelineMax()
			tl.to(this.$burger,.6,{autoAlpha:0, ease: Power0.easeNone},0)
			tl.staggerTo(this.$navItem,.6,{y:-40,autoAlpha:0,ease: Expo.easeIn},.05,0)

			this.$events.emit('menu.in')
		}

		creditsIn () {

			let tl = new TimelineMax()
			tl.to(this.$burger,.6,{autoAlpha:0, ease: Power0.easeNone},0)
			tl.staggerTo(this.$navItem,.6,{y:-40,autoAlpha:0,ease: Expo.easeIn},.05,0)

			this.$events.emit('credits.in')
		}

		menuOut () {

			let tl = new TimelineMax()
			tl.to(this.$burger,.6,{autoAlpha:1, ease: Power0.easeNone},0)
			tl.set(this.$navItem,{y:0},0)
			tl.staggerTo(this.$navItem,.6,{autoAlpha:1,ease: Expo.easeIn},.1,0)
		
		}

		show () {
			TweenMax.to(this.$el,.6,{y:'0%'})
		}

		hide () {
			TweenMax.to(this.$el,.6,{y:'-100%'})
		}

		_resize () {
		}	

	}

	export default Header

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.header
		position fixed
		top 0
		left 0
		width 100vw
		z-index 80
		overflow hidden
		transform translateY(-100%)

		&-wrapper
			padding 40px 5vw
			display flex
			justify-content flex-end
			position relative

			.su-logo
				position absolute
				top 0
				left 0
				width 80px

				img
					width 100%

			.burger-button
				position absolute
				top 42px
				left calc(50% - 10px)

			.nav
				display flex
				align-items center

				p,a
					color #fff
					font-size 14px
					letter-spacing .15em
					font-family $FONT_SECONDARY
					font-weight 300
					text-transform uppercase

				.credits-link
					margin 0 20px
					border 1px solid #fff
					padding .2em .4em
					cursor pointer




</style>


// WEBPACK FOOTER //
// header.vue?51b2e1ac